module.exports = __webpack_public_path__ + "static/media/member-emblem-yellow.60eab641.png";